import { useCallback } from 'react';
import { useOpenLayers } from '../../react-ol';

/**
 * Selects a feature by it's id and use select interaction to select feature programtically
 *
 * Selected feature style will be applied by the selected interaction
 *
 * **Use this hook only if the layer which contains feature to select has Select interaction enabled (ex: Geometry component which uses Select inetraction)**
 *
 */
export function useSelectInteractionEvent() {
  var {
    map
  } = useOpenLayers();
  var selectFeatureById = useCallback(_ref => {
    var _layer$getSource;

    var {
      featureId,
      layerId
    } = _ref;
    var layer = map === null || map === void 0 ? void 0 : map.getLayers().getArray().find(l => l.get('id') === layerId);
    var feature = layer === null || layer === void 0 ? void 0 : (_layer$getSource = layer.getSource()) === null || _layer$getSource === void 0 ? void 0 : _layer$getSource.getFeatureById(featureId);
    var selectInteraction = map === null || map === void 0 ? void 0 : map.getInteractions().getArray().find(i => i.get('interactionId') === "".concat(layerId, "-interaction"));

    if (!feature || !selectInteraction) {
      !feature && console.warn("Unable to find with feature with ID: ".concat(featureId));
      !selectInteraction && console.warn("Unable to find with Select interaction with ID: ".concat(layerId, "-interaction"));
      return;
    } // Clear previously selected features and select the new feature


    selectInteraction.getFeatures().clear();
    selectInteraction.getFeatures().push(feature);
  }, [map]);
  return {
    selectFeatureById
  };
}